import { CSSObject } from '@chakra-ui/react';

export const ForgotPasswordButton: CSSObject = {
  color: 'blackAlpha.700',
};
